import { rootApi } from '../rootApi';
import { APIResponse, PaginatedResponse } from '../api.types';

/** A candidate put forward on a deal (JT1-1887). `candidate.id` is the OrganizationCandidate id. */
export interface IDealCandidateLink {
  id: string;
  note: string | null;
  created_at: string;
  added_by: { id: string; first_name: string; last_name: string } | null;
  candidate: { id: string; first_name: string | null; last_name: string | null; position_title: string | null };
}

// Kept apart from deal-flow.service, with its own tag, so the deal module's busy service file doesn't change.
const api = rootApi.enhanceEndpoints({ addTagTypes: ['DealCandidateLinks'] });

export const dealCandidatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDealCandidateLinks: builder.query<PaginatedResponse<IDealCandidateLink>, { dealId: string; page: number; perPage: number }>({
      query: ({ dealId, page, perPage }) => ({ url: `/deal-flow/deals/${dealId}/candidate-links`, params: { page, per_page: perPage } }),
      providesTags: (_result, _error, { dealId }) => [{ type: 'DealCandidateLinks', id: dealId }],
    }),

    addDealCandidateLinks: builder.mutation<PaginatedResponse<IDealCandidateLink>, { dealId: string; organization_candidate_ids: string[]; note?: string }>({
      query: ({ dealId, ...data }) => ({ url: `/deal-flow/deals/${dealId}/candidate-links`, method: 'POST', data }),
      invalidatesTags: (_result, _error, { dealId }) => [{ type: 'DealCandidateLinks', id: dealId }],
    }),

    removeDealCandidateLink: builder.mutation<APIResponse, { dealId: string; linkId: string }>({
      query: ({ dealId, linkId }) => ({ url: `/deal-flow/deals/${dealId}/candidate-links/${linkId}`, method: 'DELETE' }),
      invalidatesTags: (_result, _error, { dealId }) => [{ type: 'DealCandidateLinks', id: dealId }],
    }),
  }),
});

export const {
  useGetDealCandidateLinksQuery,
  useAddDealCandidateLinksMutation,
  useRemoveDealCandidateLinkMutation,
} = dealCandidatesApi;
